






















































import { Component, Vue } from 'vue-property-decorator';
import { QuoteAddress, ShippingMethod, StoreLocator, PickupPoint } from '@/store/models';
import store from '@/store';
import checkout from '@/store/modules/checkout';
import pickuppoint from '@/store/modules/pickuppoint';
import storelocator from '@/store/modules/storelocator';

@Component({})
export default class SelectedShippingInfo extends Vue {

  get selectedMethod(): ShippingMethod {
    return checkout.selectedShippingMethod;
  }

  get isStorePickup(): boolean {
    return checkout.isDefaultStorePickup;
  }

  get isPickupPoint(): boolean {
    return checkout.shipmethodSelection === 'pickuppoints_pickuppoints';
  }

  get isCustomerAddressShowable(): boolean {
    return checkout.shipmethodSelection !== store.state.options.carrier.pickup_method;
  }

  get isRuPickup(): boolean {
    return checkout.isRuStorePickup;
  }

  get address(): QuoteAddress {
    return checkout.shippingAddress;
  }

  get pickupPoint(): PickupPoint {
    return pickuppoint.selectedPoint.data;
  }

  get isRegionOptional(): boolean {
    return store.state.options.countrysettings.is_region_optional;
  }

  get countryName() {
    const country = store.state.countryData.countries.find((c: any) => c.code === this.address.country_id);
    return country ? country.name : this.address.country_id;
  }

  get streetNumber(): string {
    return this.address.custom_attributes.find((att: any) => att.attribute_code === 'tdy_street_number').value;
  }

  get extraAddress(): string {
    return this.address.custom_attributes.find((att: any) => att.attribute_code === 'tdy_extra_address').value;
  }

  get selectedStorePickup(): StoreLocator {
    return storelocator.storeById(storelocator.selectedStoreId);
  }
}
